export const safeGetEntity = (obj) => {
  if (!obj || !Object.keys(obj).length || obj?.id === 0) return ""

  return obj
}

export const getId = (obj) => obj.id
